import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import type { ArticleSummary } from "@/lib/shopify/types";

const MAX_RECENTLY_VIEWED = 10;

interface BlogState {
	recentlyViewed: ArticleSummary[];
	addRecentlyViewed: (article: ArticleSummary) => void;
	clearRecentlyViewed: () => void;

	selectedTag: string | null;
	setSelectedTag: (tag: string | null) => void;

	currentPage: number;
	setCurrentPage: (page: number) => void;
}

export const useBlogStore = create<BlogState>()(
	persist(
		(set, get) => ({
			recentlyViewed: [],
			addRecentlyViewed: (article) => {
				const current = get().recentlyViewed;
				const filtered = current.filter((a) => a.id !== article.id);
				const updated = [article, ...filtered].slice(0, MAX_RECENTLY_VIEWED);
				set({ recentlyViewed: updated });
			},
			clearRecentlyViewed: () => set({ recentlyViewed: [] }),

			selectedTag: null,
			setSelectedTag: (tag) => set({ selectedTag: tag, currentPage: 1 }),

			currentPage: 1,
			setCurrentPage: (page) => set({ currentPage: page }),
		}),
		{
			name: "blog-store",
			storage: createJSONStorage(() => localStorage),
			partialize: (state) => ({
				recentlyViewed: state.recentlyViewed,
			}),
		},
	),
);

export function useRecentlyViewed() {
	return useBlogStore((s) => s.recentlyViewed);
}

export function useSelectedTag() {
	return useBlogStore((s) => s.selectedTag);
}
